import React from 'react';

import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { Badge } from 'reactstrap';

import DeprecatingTag from './DeprecatingTag';

const SideNavItemLink = (props) => {
   return (
      <li>
         {
            props.path
            && (
               <NavLink
                  to={ props.path}
                  className={`non-collapsable sidebar-link ${ props.isActive ? 'active' : '' } ${ props.isComingSoon ? 'is-coming-soon' : '' }`}
                  activeClassName='active'
               >
                  {
                     props.icon
                        ? <props.icon size={ 18 } className='align-middle mr-3'/>
                        : null
                  }
                  { props.name }
                  { props.deprecating
                     ? <DeprecatingTag tagText={ props.deprecatingText }/>
                     : null}
                  { props.ported
                     ? <Badge color='success' className='ml-2 align-middle'>NEW</Badge>
                     : null}
                  {
                     props.badgeColor && props.badgeText
                        ? (
                           <Badge color={ props.badgeColor } size={ 18 } className='sidebar-badge'>
                              { props.badgeText }
                           </Badge>
                        ) : null
                  }
               </NavLink>
            )
         }
         {
            !props.path
            && (
               <div className='non-collapsable sidebar-link is-coming-soon'>
                  { props.name }
                  { props.deprecating
                     ? <DeprecatingTag tagText={ props.deprecatingText }/>
                     : null}
               </div>
            )
         }
      </li>
   );
};

SideNavItemLink.propTypes = {
   name: PropTypes.string.isRequired,
   path: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(null)]),
   isActive: PropTypes.bool.isRequired,
   isComingSoon: PropTypes.bool,
   icon: PropTypes.node,
   deprecating: PropTypes.bool,
   deprecatingText: PropTypes.string,
   ported: PropTypes.bool,
};

SideNavItemLink.defaultProps = {
   isComingSoon: false,
   deprecating: false,
   ported: false,
   path: undefined,
   icon: null,
};

export default SideNavItemLink;
